export enum LegalDescriptionType {
  LOT_AND_BLOCK = 'Lot and block',
  SUBDIVISION = 'Subdivision',
  METES_AND_BOUNDS = 'Metes and bounds',
  OTHER = 'Other',
}

// Helper to convert enum to dropdown options
export const getLegalDescriptionTypeOptions = () => [
  { name: 'Lot and block', value: LegalDescriptionType.LOT_AND_BLOCK },
  { name: 'Subdivision', value: LegalDescriptionType.SUBDIVISION },
  { name: 'Metes and bounds', value: LegalDescriptionType.METES_AND_BOUNDS },
  { name: 'Other', value: LegalDescriptionType.OTHER },
];
